/**
 * KanbanColumn - Column for Kanban board
 */
import React from 'react';
import { Droppable } from '@hello-pangea/dnd';
import { Task, TaskStatus, TASK_STATUS_LABELS } from '../../types/task';
import { TaskCard } from './TaskCard';

interface KanbanColumnProps {
  status: TaskStatus;
  tasks: Task[];
  onTaskClick: (task: Task) => void;
}

export const KanbanColumn: React.FC<KanbanColumnProps> = ({ status, tasks, onTaskClick }) => {
  return (
    <div className={`kanban-column ${status}`}>
      {/* Column header */}
      <div className="kanban-column-header">
        <div className="kanban-column-title">
          {TASK_STATUS_LABELS[status]}
        </div>
        <span className="kanban-column-count">
          {tasks.length}
        </span>
      </div>

      {/* Droppable area */}
      <Droppable droppableId={status}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`kanban-column-content ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
          >
            {tasks.map((task, index) => (
              <TaskCard
                key={task.id}
                task={task}
                index={index}
                onClick={() => onTaskClick(task)}
              />
            ))}
            {provided.placeholder}

            {/* Empty state */}
            {tasks.length === 0 && (
              <div className="kanban-column-empty">
                Žiadne úlohy
              </div>
            )}
          </div>
        )}
      </Droppable>
    </div>
  );
};

